export class DynamoDBRestoreMethodAvailabilityRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreMethod",
            "baseName": "restoreMethod",
            "type": "RestoreMethod",
            "format": ""
        },
        {
            "name": "destination",
            "baseName": "destination",
            "type": "DynamodbTableRestoreDestination",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DynamoDBRestoreMethodAvailabilityRequest.attributeTypeMap;
    }
    constructor() {
    }
}
